const communicationChannelsUTMs: any = [
  {
    utm_source: "postmark",
    utm_medium: "email",
  },
  {
    utm_source: "whatsapp",
    utm_medium: "system",
  },
  {
    utm_source: "sms",
    utm_medium: "syatem",
  },
];
const isFromCommunicationChannels = (queryparams: any) =>
  communicationChannelsUTMs.some((utm: any) =>
    Object.keys(utm).every((key) => queryparams.get(key) === utm[key]),
  );

export default isFromCommunicationChannels;
